<template>
  <v-select
    label="Business Type"
    outlined dense
    :items="items"
    :value="value"
    @input="(newVal) => $emit('input', newVal)"
  />
</template>

<script>
export default {
  name: 'BusinessTypeSelect',

  props: ['value'],

  data: () => ({
    items: [
      'Individual/Sole Proprietor or Single-Member LLC',
      'C Corporation',
      'S Corporation',
      'Partnership',
      'LLC',
    ]
  }),
}
</script>